import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteForever from '@mui/icons-material/DeleteForever';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Alert, AlertTitle } from '@mui/material';
import Menu from '../MenuBar';
import { ImageList } from '@mui/material';
import PrintPDFRef from '../PrintRefeference/PrintPDFRef';
import setPrintPDFAction from '../../redux/actions/showReferenceActions/actionPDFPrint';
import ViewDetailsImageGalery from './ViewDetailsImageGalery';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { ArrowLeftSquareFill } from 'react-bootstrap-icons';
import { withTranslation } from 'react-i18next';
import checkToken from '../../Token/checkToken'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import setShowRefAction from '../../redux/actions/showReferenceActions/actionShowRef';

const ViewRefDetails = ({ classes, t }) => {

    //const selectedReferenceData = useSelector(state => state.showRefState.selectedReferenceData)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [selectedReferenceData, setSelectedReferenceData] = useState(null)
    const pdfPrintData = useSelector(state => state.showRefState.pdfPrintData);
    const [tempPdfPrintData, setPdfPrintData] = useState(null);
    const [images, setImages] = useState(null);
    const [count, setCount] = useState(1);
    const [referenceDeleted, setReferenceDeleted] = useState(false);
    const [openError, setOpenError] = useState(false)
    const [openImage, setOpenImage] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [matches, setMatches] = useState(window.matchMedia("(min-width: 768px)").matches);
    const [date_from, setDateFrom] = useState(null);
    const [date_to, setDateTo] = useState(null);
    const [loading, setLoading] = useState(false);
    const { id } = useParams()

    useEffect(() => {

        if (id) {
            fetchData();
        }

        setLoading(true)
        const handler = e => setMatches(e.matches);
        window.matchMedia("(min-width: 768px)").addListener(handler);
        return () => {
            window.matchMedia("(min-width: 768px)").removeListener(handler);
        };
    }, []);

    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/viewRef/getRef/:id?id=${id}&language=${localStorage.getItem('language')}&firm=${localStorage.getItem('firm')}`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('jwToken')}`
                }
            });
            setPdfPrintData(pdfPrintData);
            const data = await response.json();
            if (data.data[0]) {
                setSelectedReferenceData(data.data[0]);
                setDateFrom(formatDate(data.data[0].date_from))
                setDateTo(formatDate(data.data[0].date_to))
                setOpenError(false)
                setImages(data.data[0].image1)
                //Für ViewDetailsImageGalery
                dispatch(setShowRefAction(data.data[0]))
                //Für PDF-Print
                dispatch(setPrintPDFAction(data.data))
            } else {
                setOpenError(true)
            }

        } catch (error) {
            setOpenError(true)
            console.error('Error fetching data:', error);
        }
    }

    const handleCloseDialog = () => {
        setDeleteConfirm(false)
        setOpenError(false)
    };

    const formatDate = (date) => {
        let date_to = new Date(date);
        let day = date_to.getDate().toString().padStart(2, '0'); // Tag mit führender 0
        let month = (date_to.getMonth() + 1).toString().padStart(2, '0'); // Monat mit führender 0
        let year = date_to.getFullYear(); // Jahr
        let formattedDate = `${day}.${month}.${year}`
        return formattedDate
    };

    const handleShowImageDialog = () => {
        setOpenImage(!openImage);
    };

    const handleNextImg = () => {
        setCount(count + 1);
        let imageString = 'image' + (count + 1).toString();
        if (selectedReferenceData[imageString] !== undefined) {
            setImages(selectedReferenceData[imageString]);
        } else {
            setCount(count - 1);
        }
    };

    const handleConfirmDelete = async () => {
        const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/viewRef/deleteRef?id=${selectedReferenceData.id}&refId=${selectedReferenceData.user_id}`);
        if (response.status === 200) {
            setReferenceDeleted(true);
            setDeleteConfirm(false);
            setTimeout(() => window.location.href = "/searchRef", 2000);
        }
    }
    const handleDelete = async () => {
        setDeleteConfirm(true)
    };

    const handleEdit = () => {
        navigate('/editRef');
    };

    const handleBack = () => {
        dispatch(setPrintPDFAction(tempPdfPrintData))
        navigate(-1);
    };

    const handleBackImg = () => {
        if (count !== 0 && count !== 1) {
            setCount(count - 1);
            let imageString = 'image' + (count - 1).toString();
            if (selectedReferenceData[imageString] !== undefined) {
                setImages(selectedReferenceData[imageString]);
            } else {
                setCount(count + 1);
                setImages(selectedReferenceData.image1);
            }
        }
    };

    return (
        <div className='createRefClassFull'>
            {checkToken() ? (
                <div>
                    <Menu />
                    {selectedReferenceData && loading ? (
                        <div className='createRefClass'>

                            {/* ################################################## RESPONSIVE ################################################## */}

                            {matches && (
                                <Card style={{ width: 768, margin: 10, backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>

                                    <CardHeader style={{ color: 'white' }} titleTypographyProps={{ variant: 'subtitle1' }}
                                        action={
                                            <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Go back</h6>}>
                                                <IconButton style={{ size: 'small' }} aria-label="nextImage" onClick={handleBack} >
                                                    <ArrowLeftSquareFill style={{ color: 'white' }} />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        title={selectedReferenceData.title}
                                    />
                                    <ViewDetailsImageGalery />
                                    {(parseInt(localStorage.getItem('role_id')) != 1 && <PrintPDFRef />)}
                                    {(selectedReferenceData.user_id === localStorage.getItem('user_id') || parseInt(localStorage.getItem('role_id')) === 1) &&
                                        <div style={{display: 'flex', justifyContent: 'center', backgroundColor: 'rgba(1, 26, 35, 0.1)' }}>
                                            <Tooltip placement="right" title={<h6 style={{ color: "white" }}>Delete reference</h6>}>
                                            <IconButton style={{ size: 'small' }} aria-label="deleteImage" onClick={handleDelete} >
                                                <DeleteForever style={{ color: 'white' }} />
                                            </IconButton>
                                            </Tooltip>
                                            <Dialog open={deleteConfirm} onClose={handleCloseDialog}>
                                                <Alert severity="warning">
                                                    <DialogTitle>{t("view_ref.delete_ref")}</DialogTitle>
                                                    <DialogActions>
                                                        <Button onClick={handleCloseDialog} color="primary">{t("view_ref.lean")}</Button>
                                                        <Button onClick={handleConfirmDelete} color="primary">{t("view_ref.confirm")}</Button>
                                                    </DialogActions>
                                                </Alert>
                                            </Dialog>
                                            {/* </Tooltip> */}
                                            <PrintPDFRef />
                                            <Tooltip placement="right" title={<h6 style={{ color: "white" }}>Edit reference</h6>}>
                                                <IconButton style={{ size: 'small' }} aria-label="deleteImage" onClick={handleEdit} >
                                                    <EditOutlinedIcon style={{ color: 'white' }} />
                                                </IconButton>
                                            </Tooltip>

                                            <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={referenceDeleted}>
                                                <Alert severity="success">
                                                    <AlertTitle>Success</AlertTitle>
                                                    The reference was successfully deleted!
                                                </Alert>
                                            </Dialog>

                                        </div>
                                    } 
                                    <CardContent style={{ color: 'white', textAlign: 'left' }}>
                                        <b> {t("create_ref.country")}: </b> {selectedReferenceData.country}
                                        <br />
                                        <b> {t("create_ref.province")}: </b> {selectedReferenceData.province}
                                        <br />
                                        <b> {t("create_ref.city")}: </b> {selectedReferenceData.zip} {selectedReferenceData.city}
                                        <br />
                                        <b> {t("create_ref.street")}: </b> {selectedReferenceData.street}
                                        <br />
                                        <b> {t("create_ref.foe")}: </b> {selectedReferenceData.foe}
                                        <br />
                                        <b> {t("create_ref.date_from")}: </b> {date_from}
                                        <br />
                                        <b> {t("create_ref.date_to")}: </b> {date_to}
                                        <br />
                                        <b> {t("view_ref.creator")}: </b> {selectedReferenceData.firstname + ' ' + selectedReferenceData.lastname}
                                        <br />
                                    </CardContent>
                                </Card>
                            )}

                            {matches && (
                                <Accordion style={{ width: 768, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                    >
                                        <Typography > <b>{t("create_ref.products_placeholder")}</b></Typography>
                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <Typography style={{ width: 768, justifyContent: 'center', textAlign: 'left' }}>
                                            {selectedReferenceData !== undefined &&
                                                <>
                                                    <b> {t("view_ref.product")} 1: {selectedReferenceData.productname_1}<br /> </b>
                                                    {selectedReferenceData.productname_2 !== null && <b> {t("view_ref.product")} 2: {selectedReferenceData.productname_2}<br /> </b>}
                                                    {selectedReferenceData.productname_3 !== null && <b> {t("view_ref.product")} 3: {selectedReferenceData.productname_3}<br /> </b>}
                                                    {selectedReferenceData.productname_4 !== null && <b> {t("view_ref.product")} 4: {selectedReferenceData.productname_4}<br /> </b>}
                                                    {selectedReferenceData.productname_5 !== null && <b> {t("view_ref.product")} 5: {selectedReferenceData.productname_5}<br /> </b>}
                                                    {selectedReferenceData.productname_6 !== null && <b> {t("view_ref.product")} 6: {selectedReferenceData.productname_6}<br /> </b>}
                                                    {selectedReferenceData.productname_7 !== null && <b> {t("view_ref.product")} 7: {selectedReferenceData.productname_7}<br /> </b>}
                                                    {selectedReferenceData.productname_8 !== null && <b> {t("view_ref.product")} 8: {selectedReferenceData.productname_8}<br /> </b>}
                                                    {selectedReferenceData.productname_9 !== null && <b> {t("view_ref.product")} 9: {selectedReferenceData.productname_9}<br /> </b>}
                                                    {selectedReferenceData.productname_10 !== null && <b> {t("view_ref.product")} 10: {selectedReferenceData.productname_10}<br /> </b>}
                                                </>
                                            }
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            )}

                            {matches && (<Accordion style={{ width: 768, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>{t("search_ref.search_prod_sys")}</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography style={{ width: 300, justifyContent: 'center', textAlign: 'left' }}>
                                        {selectedReferenceData.prodsys_1 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 1: {selectedReferenceData.prodsys_1} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_2 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 2: {selectedReferenceData.prodsys_2} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_3 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 3: {selectedReferenceData.prodsys_3} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_4 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 4: {selectedReferenceData.prodsys_4} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_5 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 5: {selectedReferenceData.prodsys_5} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_6 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 6: {selectedReferenceData.prodsys_6} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_7 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 7: {selectedReferenceData.prodsys_7} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_8 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 8: {selectedReferenceData.prodsys_8} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_9 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 9: {selectedReferenceData.prodsys_9} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_10 !== 'null' ?
                                            <b> {t("search_ref.search_prod_sys")} 10: {selectedReferenceData.prodsys_10} <br /> </b> : null}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>)}

                            {matches && (<Accordion TransitionProps={{ unmountOnExit: true }} style={{ width: 768, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>{t("create_ref.textaccordion_description")}</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ margin: 5, padding: 0 }}>
                                    <ImageList rowHeight={200} cols={1}>
                                        <Typography style={{ width: 768, justifyContent: 'center', textAlign: 'left' }}>
                                            <b> {t("create_ref.textaccordion_description")}: </b> {selectedReferenceData.description}
                                            <br />
                                            <br />
                                            <b> {t("view_ref.comment_for_contactor")}: </b>  {selectedReferenceData.comment_contactor}
                                            <br />
                                            <br />
                                            <b> {t("view_ref.comment_for_planer")}: </b>  {selectedReferenceData.comment_planer}
                                            <br />
                                            <br />
                                            <b> {t("view_ref.comment_for_owner")}: </b>  {selectedReferenceData.comment_owner}
                                            <br />
                                            <br />
                                        </Typography>
                                    </ImageList>
                                </AccordionDetails>
                            </Accordion>)}

                            {matches && (<Accordion TransitionProps={{ unmountOnExit: true }} style={{ width: 768, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)', marginBottom: 10 }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>{t("create_ref.textaccordion_long_description")}</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ margin: 5, padding: 0 }}>
                                    <ImageList rowHeight={200} cols={1}>
                                        <Typography style={{ width: 768, justifyContent: 'center', textAlign: 'left' }}>
                                            <b> {t("create_ref.textaccordion_long_description")}: </b> {selectedReferenceData.long_description}
                                        </Typography>
                                    </ImageList>
                                </AccordionDetails>
                            </Accordion>
                            )}

                            {/* ########################################################################################################### */}

                            {!matches && (<Card style={{ width: 300, margin: 10, backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>

                                <CardHeader style={{ color: 'white' }} titleTypographyProps={{ variant: 'subtitle1' }}
                                    action={
                                        <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Go back</h6>}>
                                            <IconButton style={{ size: 'small' }} aria-label="nextImage" onClick={handleBack} >
                                                <ArrowLeftSquareFill style={{ color: 'white' }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    title={selectedReferenceData.title}
                                />
                                <CardActionArea onClick={handleShowImageDialog}>
                                    <CardMedia style={{ height: 0, paddingTop: '56%' }}
                                        image={process.env.REACT_APP_EXPRESS_SERVER + '/ImagesForPDF/' + selectedReferenceData.image1.substring(selectedReferenceData.image1.lastIndexOf('-') + 1, selectedReferenceData.image1.lastIndexOf('.')) + '/' + images}
                                        height="140"
                                    />
                                    <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={openImage}>

                                        <img src={process.env.REACT_APP_EXPRESS_SERVER + '/ImagesForPDF/' + selectedReferenceData.image1.substring(selectedReferenceData.image1.lastIndexOf('-') + 1, selectedReferenceData.image1.lastIndexOf('.')) + '/' + images} alt="Logo" />

                                    </Dialog>
                                </CardActionArea>
                                <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgba(1, 26, 35, 0.1)' }}>

                                    <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Previous image</h6>}>
                                        <IconButton style={{ size: 'small' }} aria-label="nextImage" onClick={handleBackImg} >
                                            <ArrowBackIos style={{ color: 'white' }} />
                                        </IconButton>
                                    </Tooltip>
                                    <PrintPDFRef />
                                    <Tooltip placement="right" title={<h6 style={{ color: "white" }}>Next image</h6>}>
                                        <IconButton style={{ size: 'small' }} aria-label="previousImage" onClick={handleNextImg}  >
                                            < ArrowForwardIos style={{ color: 'white' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>

                                {selectedReferenceData.user_id === localStorage.getItem('user_id')
                                    || parseInt(localStorage.getItem('role_id')) === 1 ?
                                    < div style={{ backgroundColor: 'rgba(1, 26, 35, 0.1)' }}>
                                        <IconButton style={{ size: 'small' }} aria-label="deleteImage" onClick={handleDelete} >
                                            <DeleteForever style={{ color: 'white' }} />
                                        </IconButton>
                                        <Dialog open={deleteConfirm} onClose={handleCloseDialog}>
                                            <Alert severity="warning">
                                                <DialogTitle>{t("view_ref.delete_ref")}</DialogTitle>
                                                <DialogActions>
                                                    <Button onClick={handleCloseDialog} color="primary">{t("view_ref.lean")}</Button>
                                                    <Button onClick={handleConfirmDelete} color="primary">{t("view_ref.confirm")}</Button>
                                                </DialogActions>
                                            </Alert>
                                        </Dialog>
                                        <Tooltip placement="right" title={<h6 style={{ color: "white" }}>Edit reference</h6>}>
                                            <IconButton style={{ size: 'small' }} aria-label="deleteImage" onClick={handleEdit} >
                                                <EditOutlinedIcon style={{ color: 'white' }} />
                                            </IconButton>
                                        </Tooltip>

                                        <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={referenceDeleted}>
                                            <Alert severity="success">
                                                <AlertTitle>Success</AlertTitle>
                                                The reference was successfully deleted!
                                            </Alert>

                                        </Dialog>

                                    </div>
                                    : null}

                                <CardContent style={{ color: 'white', textAlign: 'left' }}>
                                    <b> Country: </b> {selectedReferenceData.country}
                                    <br />
                                    <b> Province: </b>  {selectedReferenceData.province}
                                    <br />
                                    <b> City: </b> {selectedReferenceData.zip} {selectedReferenceData.city}
                                    <br />
                                    <b> Street: </b> {selectedReferenceData.street}
                                    <br />
                                    <b> FOE: </b> {selectedReferenceData.foe}
                                    <br />
                                    <b> Date from: </b> {date_from}
                                    <br />
                                    <b> Date to: </b> {date_to}
                                    <br />
                                    <b> Creator: </b> {selectedReferenceData.firstname + ' ' + selectedReferenceData.lastname}
                                    <br />
                                </CardContent>
                            </Card>)}

                            {!matches && (<Accordion style={{ width: 300, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>Products</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails >
                                    <Typography style={{ width: 300, justifyContent: 'center', textAlign: 'left' }}>
                                        {selectedReferenceData !== undefined ?
                                            <b> Product 1: {selectedReferenceData.productname_1}<br /> </b> : null}
                                        {selectedReferenceData.productname_2 !== null ?
                                            <b> Product 2: {selectedReferenceData.productname_2}<br /> </b> : null}
                                        {selectedReferenceData.productname_3 !== null ?
                                            <b> Product 3: {selectedReferenceData.productname_3}<br /> </b> : null}
                                        {selectedReferenceData.productname_4 !== null ?
                                            <b> Product 4: {selectedReferenceData.productname_4}<br /> </b> : null}
                                        {selectedReferenceData.productname_5 !== null ?
                                            <b> Product 5: {selectedReferenceData.productname_5}<br /> </b> : null}
                                        {selectedReferenceData.productname_6 !== null ?
                                            <b> Product 6: {selectedReferenceData.productname_6}<br /> </b> : null}
                                        {selectedReferenceData.productname_7 !== null ?
                                            <b> Product 7: {selectedReferenceData.productname_7}<br /> </b> : null}
                                        {selectedReferenceData.productname_8 !== null ?
                                            <b> Product 8: {selectedReferenceData.productname_8}<br /> </b> : null}
                                        {selectedReferenceData.productname_9 !== null ?
                                            <b> Product 9: {selectedReferenceData.productname_9}<br /> </b> : null}
                                        {selectedReferenceData.productname_10 !== null ?
                                            <b> Product 10: {selectedReferenceData.productname_10}<br /> </b> : null}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>)}
                            {!matches && (<Accordion style={{ width: 300, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>Product System</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography style={{ width: 300, justifyContent: 'center', textAlign: 'left' }}>
                                        {selectedReferenceData.prodsys_1 !== 'null' ?
                                            <b> Productsystem 1: {selectedReferenceData.prodsys_1} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_2 !== 'null' ?
                                            <b> Productsystem 2: {selectedReferenceData.prodsys_2} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_3 !== 'null' ?
                                            <b> Productsystem 3: {selectedReferenceData.prodsys_3} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_4 !== 'null' ?
                                            <b> Productsystem 4: {selectedReferenceData.prodsys_4} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_5 !== 'null' ?
                                            <b> Productsystem 5: {selectedReferenceData.prodsys_5} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_6 !== 'null' ?
                                            <b> Productsystem 6: {selectedReferenceData.prodsys_6} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_7 !== 'null' ?
                                            <b> Productsystem 7: {selectedReferenceData.prodsys_7} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_8 !== 'null' ?
                                            <b> Productsystem 8: {selectedReferenceData.prodsys_8} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_9 !== 'null' ?
                                            <b> Productsystem 9: {selectedReferenceData.prodsys_9} <br /> </b> : null}
                                        {selectedReferenceData.prodsys_10 !== 'null' ?
                                            <b> Productsystem 10: {selectedReferenceData.prodsys_10} <br /> </b> : null}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>)}

                            {!matches && (<Accordion TransitionProps={{ unmountOnExit: true }} style={{ width: 300, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)' }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>Description</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ margin: 5, padding: 0 }}>
                                    <ImageList rowHeight={200} cols={1}>
                                        <Typography style={{ width: 300, justifyContent: 'center', textAlign: 'left' }}>
                                            <b> Description: </b> {selectedReferenceData.description}
                                            <br />
                                            <br />
                                            <b> Comment for Contractor: </b>  {selectedReferenceData.comment_contactor}
                                            <br />
                                            <br />
                                            <b> Comment for Planer: </b>  {selectedReferenceData.comment_planer}
                                            <br />
                                            <br />
                                            <b> Comment for Owner: </b>  {selectedReferenceData.comment_owner}
                                            <br />
                                            <br />
                                        </Typography>
                                    </ImageList>
                                </AccordionDetails>
                            </Accordion>)}
                            {!matches && (<Accordion TransitionProps={{ unmountOnExit: true }} style={{ width: 300, margin: 0, padding: 0, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.4)', marginBottom: 10 }} >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{ backgroundColor: 'rgba(74, 192, 221, 1)', color: 'white' }}
                                >
                                    <Typography > <b>Long Description</b></Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ margin: 5, padding: 0 }}>
                                    <ImageList rowHeight={200} cols={1}>
                                        <Typography style={{ width: 300, justifyContent: 'center', textAlign: 'left' }}>
                                            <b> Long Description: </b> {selectedReferenceData.long_description}
                                        </Typography>
                                    </ImageList>
                                </AccordionDetails>
                            </Accordion>)}

                        </div>
                    ) : (
                        <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={openError}>
                            <Alert severity="error">
                                <AlertTitle>Error</AlertTitle>
                                {t("view_ref.view_not_found_error")}
                            </Alert>
                        </Dialog>
                    )}
                </div>
            ) : (
                navigate('/login')
            )}
        </div>
    );
};


// const mapDispatchToProps = dispatch => {
//     return {
//         setPrintPDFFunction: pdfPrintData => {
//             dispatch(setPrintPDFAction(pdfPrintData));
//         }
//     };
// };

export default (withTranslation()(ViewRefDetails));